import * as React from "react";
import {Fragment} from "react";
import {Option} from "ts-option";
import DateUtils from "../../utils/DateUtils";
import moment = require("moment");

interface IComponentProps {
	/**
	 * initial moment date from reminder.
	 */
	initialDate: Option<moment.Moment>
	/**
	 * Start time in 'HH:mm' format.
	 */
	startTime?: string;
	/**
	 * End time in 'HH:mm' format.
	 */
	endTime?: string;
	/**
	 * Time picker interval in minutes.
	 */
	interval?: number;
	/**
	 * On time change handler.
	 */
	onChange: (moment: moment.Moment) => void;
}

export default class TimePicker extends React.Component<IComponentProps, {}> {

	public static defaultProps: Partial<IComponentProps> = {
		interval: 30,
		startTime: "00:00",
		endTime: "23:59"
	};

	constructor(props: IComponentProps) {
		super(props);
		this.renderTimeItems = this.renderTimeItems.bind(this);
		this.handleElementClick = this.handleElementClick.bind(this);
		this.generateTime = this.generateTime.bind(this);
	}

	refs: {
		timePicker: any
	};

	render() {
		// TODO Handle tab and enter keys, second click on input.

		return <Fragment>
			<div ref={"timePicker"} className={"c-appointment-time-picker-wrapper"}>
				<div className={"c-time-picker c-appointment-time-picker"} id={"timepicker-container"}>
					<ul>
						{this.renderTimeItems()}
					</ul>
				</div>
			</div>
		</Fragment>;
	}

	renderTimeItems() {
		const now = moment();
		return this.generateTime().map((dateTime, index) => {
			const isPast = dateTime.isBefore(now, 'minute');

			const className = `${(isPast || this.props.initialDate.isEmpty) ? "disabled" : "hiber-time-element"}
				${(this.props.initialDate.isDefined && dateTime.isSame(this.props.initialDate.get) && !isPast) ? "selected" :
				""}`;

			const onClick = isPast ? () => {} : this.handleElementClick;
			return (
				<li key={index} onClick={() => {onClick(dateTime)}}
					className={className}>
					{dateTime.format(DateUtils.REMINDER_TIME_FORMAT)}
				</li>

			);
		});
	}

	/**
	 * Generate list of moments based on reminder date.
	 * @return {moment.Moment[]}
	 */
	generateTime() {
		const startTime = moment(this.props.startTime, "HH:mm").diff(moment().startOf("day"), "minutes");
		const endTime = moment(this.props.endTime, "HH:mm").diff(moment().startOf("day"), "minutes");
		const time = [];
		for (let t = startTime; t <= endTime; t += this.props.interval)
			time.push(moment(this.props.initialDate.getOrElse(moment())).startOf("day").add(t, "m"));
		return time;
	}

	/**
	 * Handle time item click.
	 */
	handleElementClick(moment: moment.Moment) {
		this.props.onChange(moment);
	}
}